import { TFunction } from 'i18next';
import { CampaignCsvLabels } from '../../../utils/campaignCsv';

/** Column labels for the campaign code list (#2249), in the admin's language. */
export const campaignCsvLabels = (t: TFunction): CampaignCsvLabels => ({
    code: t('vouchers_codes.campaign.csv.code'),
    email: t('vouchers_codes.campaign.csv.email'),
    redeemed: t('vouchers_codes.campaign.csv.redeemed'),
    bookings: t('vouchers_codes.campaign.csv.bookings'),
    yes: t('vouchers_codes.campaign.csv.yes'),
    no: t('vouchers_codes.campaign.csv.no'),
    missing: t('common.not_applicable'),
});
